import { DirectionalPoints } from '../../../../../../../../core/types/types';

export const filterNonPairedPoints = (highestPoints: DirectionalPoints, lowestPoints: DirectionalPoints) => {
    let highestFilteredPolygonDirectionalPoints = { ...highestPoints };
    let lowestFilteredPolygonDirectionalPoints = { ...lowestPoints };

    const highestPointsArray = Object.entries(highestPoints).map(([key, value]) => ({
        direction: key,
        ...value,
    }));

    const lowestPointsArray = Object.entries(lowestPoints).map(([key, value]) => ({
        direction: key,
        ...value,
    }));

    // console.log('highest points: ', highestPointsArray);
    // console.log('lowest points: ', lowestPointsArray);

    for (let i = 0; i < highestPointsArray.length; i++) {
        if (highestPointsArray[i].lat === 0) {
            if (highestPointsArray[i].direction === 'North') {
                lowestFilteredPolygonDirectionalPoints['South'] = { elevation: -Infinity, lat: 0, lng: 0 };
            } else if (highestPointsArray[i].direction === 'East') {
                lowestFilteredPolygonDirectionalPoints['West'] = { elevation: -Infinity, lat: 0, lng: 0 };
            } else if (highestPointsArray[i].direction === 'South') {
                lowestFilteredPolygonDirectionalPoints['North'] = { elevation: -Infinity, lat: 0, lng: 0 };
            } else if (highestPointsArray[i].direction === 'West') {
                lowestFilteredPolygonDirectionalPoints['East'] = { elevation: -Infinity, lat: 0, lng: 0 };
            } else if (highestPointsArray[i].direction === 'Northeast') {
                lowestFilteredPolygonDirectionalPoints['Southwest'] = { elevation: -Infinity, lat: 0, lng: 0 };
            } else if (highestPointsArray[i].direction === 'Northwest') {
                lowestFilteredPolygonDirectionalPoints['Southeast'] = { elevation: -Infinity, lat: 0, lng: 0 };
            } else if (highestPointsArray[i].direction === 'Southeast') {
                lowestFilteredPolygonDirectionalPoints['Northwest'] = { elevation: -Infinity, lat: 0, lng: 0 };
            } else if (highestPointsArray[i].direction === 'Southwest') {
                lowestFilteredPolygonDirectionalPoints['Northeast'] = { elevation: -Infinity, lat: 0, lng: 0 };
            }
        }
    }
    for (let i = 0; i < lowestPointsArray.length; i++) {
        if (lowestPointsArray[i].lat === 0) {
            if (lowestPointsArray[i].direction === 'North') {
                highestFilteredPolygonDirectionalPoints['South'] = { elevation: Infinity, lat: 0, lng: 0 };
            } else if (lowestPointsArray[i].direction === 'East') {
                highestFilteredPolygonDirectionalPoints['West'] = { elevation: Infinity, lat: 0, lng: 0 };
            } else if (lowestPointsArray[i].direction === 'South') {
                highestFilteredPolygonDirectionalPoints['North'] = { elevation: Infinity, lat: 0, lng: 0 };
            } else if (lowestPointsArray[i].direction === 'West') {
                highestFilteredPolygonDirectionalPoints['East'] = { elevation: Infinity, lat: 0, lng: 0 };
            } else if (lowestPointsArray[i].direction === 'Northeast') {
                highestFilteredPolygonDirectionalPoints['Southwest'] = { elevation: Infinity, lat: 0, lng: 0 };
            } else if (lowestPointsArray[i].direction === 'Northwest') {
                highestFilteredPolygonDirectionalPoints['Southeast'] = { elevation: Infinity, lat: 0, lng: 0 };
            } else if (lowestPointsArray[i].direction === 'Southwest') {
                highestFilteredPolygonDirectionalPoints['Northeast'] = { elevation: Infinity, lat: 0, lng: 0 };
            } else if (lowestPointsArray[i].direction === 'Southeast') {
                highestFilteredPolygonDirectionalPoints['Northwest'] = { elevation: Infinity, lat: 0, lng: 0 };
            }
        }
    }

    // console.log('highest filtered points: ', highestFilteredPolygonDirectionalPoints);
    // console.log('lowest filtered points: ', lowestFilteredPolygonDirectionalPoints);
    return { highestFilteredPolygonDirectionalPoints, lowestFilteredPolygonDirectionalPoints };
};
